import { Component, Input, OnDestroy, OnInit, EventEmitter } from '@angular/core';
import { TestLeftMenu, TestProvider } from '../../providers/test-provider';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NewTestFormComponent } from '../new-test-form/new-test-form';
import { ConfirmDialogComponent } from '../../../common/components/confirm-dialog/confirm-dialog';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Organization } from "../../../common/models/organization";
import { MatButtonModule } from "@angular/material/button";
import { MatListModule } from "@angular/material/list";
import { RouterLink } from "@angular/router";
import { NgForOf, NgIf } from "@angular/common";
import { MatLine } from "@angular/material/core";
import { DefaultPipe } from "../../../common/pipes/default";
import { AppDatePipe } from "../../../common/pipes/app-date";
import { MatMenuModule } from "@angular/material/menu";
import { MatIcon } from "@angular/material/icon";
import { User } from "../../../common/models/user";

@Component({
  selector: 'test-side-menu',
  standalone: true,
  providers: [],
  styleUrls: ['./side-menu.scss'],
  imports: [
    MatButtonModule,
    TranslateModule,
    MatListModule,
    RouterLink,
    NgIf,
    MatLine,
    NgForOf,
    DefaultPipe,
    AppDatePipe,
    MatMenuModule,
    MatIcon,
  ],
  templateUrl: './side-menu.html'
})
export class TestSideMenuComponent implements OnInit, OnDestroy {
  public isLoading = true;
  private subscriptions: Subscription[] = [];

  @Input()
  public tests: TestLeftMenu[] = [];

  @Input()
  public testsChange = new EventEmitter<void>();

  @Input()
  public activeTestId: number | null = null;

  @Input()
  public athleteUser: User = {} as User;

  @Input()
  public organization: Organization = {} as Organization;

  constructor(
    private testProvider: TestProvider,
    private translator: TranslateService,
    private toaster: MatSnackBar,
    private dialog: MatDialog,
  ) {}

  public ngOnInit(): void {
    this.isLoading = false;
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }


  public onVerticalMenuClick(event:any) {
    event.preventDefault();
    event.stopPropagation();
  }

  public hasOtherThanReadRights(test: TestLeftMenu) {
    return Object.entries(test.rights).some(
      ([key, value]) => key !== 'view' && value === true
    );
  }

  public addTestClicked(): void {
    const dialog = this.dialog.open(NewTestFormComponent, {
      data: {
        title: this.translator.instant('NewTest'),
        organization: this.organization,
        athlete: this.athleteUser.athlete,
      }
    });
    this.subscriptions.push(
      dialog.afterClosed().subscribe((test) => {
        if (test.id) {
          this.testsChange.emit();
        }
      })
    );
  }

  public onDuplicateClicked(test: TestLeftMenu): void {
    const dialog = this.dialog.open(NewTestFormComponent, {
      data: {
        title: this.translator.instant('EditTest'),
        organization: this.organization,
        athlete: this.athleteUser.athlete,
        originalTest: test,
      }
    });
    this.subscriptions.push(
      dialog.afterClosed().subscribe((test) => {
        if (test.id) {
          this.testsChange.emit();
        }
      })
    );
  }

  public onEditClicked(test: TestLeftMenu): void {
    const dialog = this.dialog.open(NewTestFormComponent, {
      data: {
        title: this.translator.instant('EditTest'),
        organization: this.organization,
        athlete: this.athleteUser.athlete,
        test: test,
      }
    });
    this.subscriptions.push(
      dialog.afterClosed().subscribe((test) => {
        if (test.id) {
          this.testsChange.emit();
        }
      })
    );
  }

  public onDeleteClicked(test: TestLeftMenu): void {
    const dialog: MatDialogRef<ConfirmDialogComponent> = this.dialog.open(ConfirmDialogComponent, {
      data: {
        confirmText: 'TestConfirmDelete',
        confirmActionText: 'Delete',
        confirmColor: 'primary'
      }
    });
    this.subscriptions.push(
      dialog.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.subscriptions.push(
            this.testProvider.deleteTest(this.organization, this.athleteUser, test as any).subscribe(
              () => {
                this.toaster.open(this.translator.instant('Test_Deleted'), '', {duration: 5000});
                //this.loadPaginatedData(this.currentPage + 1);
              },
              (err) => {
                this.toaster.open(err.error.message, '', { duration: 5000 });
              })
          );
        }
      })
    );
  }

}
